<template>
  <SharedHeroCarousel
    :autoplay="mgnlProps.autoplay"
    :autoplay-time="mgnlProps.autoplayTime"
    :desktop-display-mode="mgnlProps.desktopDisplayMode"
    :items="mgnlProps.items"
    :image-load-type="(mgnlProps.imageLoadType as ('eager' | 'lazy'))"
    :data-ab-id="mgnlProps.dataABId"
  />
</template>

<script lang="ts" setup>
import { HeroCarouselBuilder, WrapperProps } from '~/components/Shared/HeroCarousel/HeroCarousel.model';

const props = defineProps(WrapperProps);

const mgnlProps = HeroCarouselBuilder.build(props);
</script>
